import './App.less';
import Run from './components/Run';
import { FC, useEffect , useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { IRedirectRoute } from './model/IRedirectRoutes';
import { Helmet } from 'react-helmet';
import TagManager from 'react-gtm-module';

const titles4Pages = {
    '/': 'Compra y vende autos usados de forma segura',
    '/vehiculos': 'Cientos de vehículos y autos usados en Chile',
    '/financiamiento': 'Compra tu Usado con el mejor crédito al mejor precio',
    '/ventas': 'Vende tu Auto Usado tasado por los expertos  de Derco',
    '/locales': 'Conoce dónde comprar tu próximo auto usado',
    '/faq': 'Sección de preguntas frecuentes',
    '/faq/base': 'Bases Legales',
    '/faq/bases-legales': 'Descarga nuestras bases legales',
    '/faq/quienes-somos': 'Descubre cómo puedes comprar tu próximo auto usado',
    '/faq/terminos-y-condiciones/general': 'Términos y condiciones generales',
    '/faq/terminos-y-condiciones/privacidad': 'Términos y condiciones de privacidad',
    '/promociones': 'Cambia tu auto por otro - Renueva tu auto usado AHORA',
    '/promociones/renueva-tu-auto-usado': 'Cambia tu auto por otro - Renueva tu auto usado AHORA',
}
const defaultTitle = '404 Página No Encontrada';
const pdpTitle = 'Vehículos y autos usados cómo nuevos';

const App: FC<{}> = (props) => {

    const [redirectRoutes, setRedirectRoutes] = useState<IRedirectRoute[]>();
    const [isOkFetch  , setIsOk]  = useState(false);
    const [ title  , setTitle ]  = useState('');
    const { pathname } = useLocation();

    useEffect(() => {
        let titleFromPath = titles4Pages[pathname as keyof typeof titles4Pages];
        if( typeof titleFromPath === 'undefined') {
            const regex = new RegExp(/\/vehiculo/, 'gi');
            const regexPDP = pathname.match(regex);
            titleFromPath = regexPDP != null ? pdpTitle : defaultTitle;
        }
        setTitle( `${titleFromPath} | Autopia.cl` );
    }, [pathname]);

    useEffect(() => {

        if(!isOkFetch){
            fetch(`${process.env.REACT_APP_URL_BLOB}/config/data/redirectroutes.json`)
            .then((response) => response.json())
            .then((routes) => {

                setIsOk(true)
                setRedirectRoutes(routes)

            });
        }
    }, [ redirectRoutes , isOkFetch]);

    useEffect(() => {
        TagManager.initialize({ gtmId: process.env.REACT_APP_TAGMANAGER_ID as string})
    }, []);

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content="Cientos de autos usados para comprar y vender de forma segura" />
            </Helmet>
            <Routes>
                { redirectRoutes?.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        element={<Navigate to={route.to} replace state={route.status} />}
                    />
                ))
                }
            </Routes>
            {/* Aca se puede agregar un componente de validacion previo a correr la app*/}
            <Run />
        </>
    );
}

export default App